import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Button, Input, Modal, Spinner } from "reactstrap";

const ModalEditTreeHight = ({ toggle, modal, tree, editFunction, loading }) => {
  const [treeHeight, setTreeHeight] = useState(tree?.height ?? 0);

  return (
    <Modal
      className="modal-confirmation"
      isOpen={modal}
      toggle={toggle}
      centered
    >
      <div className="close-btn-container">
        <IoMdClose onClick={toggle} />
      </div>

      <div className="text-container">
        <h5>Editar altura da Árvore #{tree.id}</h5>

        {loading ? (
          <div className="loading-container">
            <Spinner size="sm" color="primary" /> Carregando...
          </div>
        ) : (
          <div className="form-group">
            <label htmlFor="tree-height">Altura (em metros)</label>
            <Input
              id="tree-height"
              type="number"
              min="0"
              step="0.1"
              value={treeHeight}
              onChange={(e) => setTreeHeight(Number(e.target.value))}
              placeholder="Digite a altura"
            />
          </div>
        )}
      </div>

      <div className="btn-container">
        <Button color="danger" onClick={() => editFunction(tree, treeHeight)}>
          Salvar
        </Button>
        <Button color="primary" onClick={toggle}>
          Cancelar
        </Button>
      </div>
    </Modal>
  );
};

export default ModalEditTreeHight;
